export default function gqlSanitize(json) {
  return JSON.stringify(json).replace(/"/g, '')
}
